import React, { useEffect, useState } from "react";
import { Table, Modal, Alert } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { useHistory } from "react-router-dom";
import { baseUrl, domainStudent } from "../../../services/config";
import Pagination from "@material-ui/lab/Pagination";

import EditStudent from "./EditStudent/EditStudent";
import { Paper } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";

import { useAlert } from "react-alert";
import usePagination from "../../../components/usePagination/usePagination";
import ViewStudent from "../Student/ViewStudent/ViewStudent";
import { PremissionChecker } from "../../../services/PremissionChecker";

function ActiveStudents() {
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  const alert = useAlert();
  const [students, setstudents] = useState([]);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [classes, setClasses] = useState([]);
  const [searchtext, setsearchtext] = useState("");
  const [currentId, setcurrentId] = useState("");
  const [loading, setloading] = useState(false);
  const [deleteModal, setdeleteModal] = useState(false);
  const [editModal, seteditModal] = useState(false);
  const [selectedcampus, setselectedcampus] = useState("");
  const [selectedStudent, setselectedStudent] = useState([]);
  const [deleteLoading, setdeleteLoading] = useState(false);
  const [stuckoffmodal, setstuckoffmodal] = useState(false);
  const [loginmodal, setloginmodal] = useState(false);

  const [loginpassword, setloginpassword] = useState("");
  const [loginemail, setloginemail] = useState("");
  const [isloginemail, setisloginemail] = useState(false);
  const [allDefinedFees, setallDefinedFees] = useState([]);
  //pagination states
  const [sessionData, setSessionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setpostPerPage] = useState(10);
  const [stuckoffloading, setstuckoffloading] = useState(false);

  const [loginemailloader, setloginemailloader] = useState(false);
  const [selectedSection, setselectedsection] = useState("");
  const [allconcessions, setallconcessions] = useState([]);
  const [allhostel, setallHostel] = useState([]);
  const [allVehical, setallVehical] = useState([]);
  const [previousSchoolData, setPreviousSchoolData] = useState([]);
  const [defaulthol, setDefaulthol] = useState([]);
  const [defaultCon, setDefaultCon] = useState([]);
  const [defaultVel, setDefaultVel] = useState([]);
  const [defaultSchool, setDefaultSchool] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [yearId, setYearId] = useState("");
  const [dateData, setDateData] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [viewSelectedId, setViewSelectedId] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();
  let campusidget = useSelector((state) => state.campuses.setselectedcampusid);
  const [previousselectedcampus, setpreviousselectedcampus] = useState(
    campusidget
  );

  //@_pagination
  const indexOfLastPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLastPost - postPerPage;
  // searching
  const dataSearch = students.filter((user) => {
    let text = searchtext.toLowerCase();
    return searchtext
      ? user.name?.toLowerCase().includes(text) ||
          user?.admission_id?.toLowerCase().includes(text)
      : true;
  });

  const currentPosts = dataSearch.slice(indexOfFirstPost, indexOfLastPost);

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(students.length / PER_PAGE);
  const _DATA = usePagination(students, PER_PAGE);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  useEffect(() => {
    if (campusidget != "") {
      setpreviousselectedcampus(campusidget);
      getAllStudents("", campusidget);
    }
    sessions();
    getConcessionTypes();
    getHostelID();
    getVehicleID();
    getPreviousSchool();
  }, []);

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllStudents = async (e, value) => {
    let id;
    let data;
    if (e) {
      id = e.target.value;
      setselectedcampus(id);
      onChampusChange(id);
    } else {
      id = value;
    }
    dispatch({
      type: "SELECTED_CAMPUS_ID",
      payload: {
        setselectedcampusid: id,
      },
    });
    setpreviousselectedcampus(id);
    data = {
      campus_id: id,
      status: 2,
    };

    if (e) {
    }
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = async (campusId) => {
    setCampusCourseData([]);
    setCourseClassData([]);
    setClassSectionData([]);

    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = async (courseId) => {
    setCourseClassData([]);
    setClassSectionData([]);

    if (courseId == "") {
      return alert.error("Please Select Course");
    }

    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onChampusChange = (id) => {
    fetch(`${baseUrl}/campusclass/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.payload) {
          setClasses(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const gotoviewpage = (student) => {
    const id = student.id;
    setViewSelectedId(id);
    setselectedStudent(student);
    setShowModal(true);
  };

  const stuckOffFun = (student) => {
    setstuckoffmodal(true);
    setselectedStudent(student);
  };

  const openEditDialog = (student) => {
    setDefaultCon([]);
    setDefaulthol([]);
    setDefaultVel([]);
    setDefaultSchool([]);
    setselectedStudent(student);
    if (student.concession_id != null) {
      const defaultValue = allconcessions.find(
        (item) => item.id == student.concession_id
      );
      setDefaultCon(defaultValue);
    }
    if (student.hostel_id != null) {
      const defaultValue = allhostel.find(
        (item) => item.id == student.hostel_id
      );
      setDefaulthol(defaultValue);
    }
    if (student.vehicle_id != null) {
      const defaultValue = allVehical.find(
        (item) => item.id == student.vehicle_id
      );
      setDefaultVel(defaultValue);
    }
    if (student.previous_school_id != null) {
      const defaultValue = previousSchoolData.find(
        (item) => item.id == student.previous_school_id
      );
      setDefaultSchool(defaultValue);
    }
    seteditModal(true);
  };

  const deleteDialog = (id) => {
    setdeleteModal(true);
    setcurrentId(id);
  };

  const deleteHandler = () => {
    fetch(`${baseUrl}/student/${currentId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }).then((res) => {
      res
        .json()
        .then((data) => {
          setdeleteModal(false);

          if (data.metadata) {
            if (data.metadata.success) {
              alert.success("Student Deleted success");
            } else {
              alert.error("Error Occured");
            }
          } else {
            alert.error("Error Occured");
          }
        })
        .catch((err) => {
          setdeleteModal(false);
          alert.error("Error Occured");
          console.log("err", err);
        });
    });
  };

  const stuckOffHandler = () => {
    setstuckoffloading(true);
    let data = {
      date: dateData,
      student_id: selectedStudent.id,
    };
    fetch(`${baseUrl}/student_struct_off`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    }).then((res) => {
      res
        .json()
        .then((data) => {
          setstuckoffloading(false);
          // previousselectedcampus
          setstuckoffmodal(false);
          if (data.metadata) {
            if (data.metadata.success) {
              getAllStudents("", previousselectedcampus);
              alert.success("Student Stuck Off Successfully");
            } else {
              alert.error("Error Occured");
            }
          } else {
            alert.error("Error Occured");
          }
        })
        .catch((err) => {
          setstuckoffloading(false);
          setstuckoffmodal(false);
          console.log("err", err);
          alert.error("Error Occured");
        });
    });
  };

  const loginHandler = () => {
    if (loginpassword == "" || loginpassword.length < 6) {
      setisloginemail(true);
      return;
    }
    setisloginemail(false);
    let data = {
      password: loginpassword,
      student_id: selectedStudent.id,
    };
    setloginemailloader(true);
    let url = "";
    if (selectedStudent.user_id == null) {
      url = "student_signup";
    } else {
      url = "student_auth_update";
    }

    fetch(`${baseUrl}/${url}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    }).then((res) => {
      res
        .json()
        .then((data) => {
          setloginemailloader(false);

          if (data.metadata) {
            if (data.metadata.success) {
              if (selectedStudent.user_id == null) {
                alert.success("Password Created Successfully");
                getAllStudents("", previousselectedcampus);
              } else {
                alert.success("Password Updated Successfully");
              }
            } else {
              alert.error("Error Occured");
            }
          } else {
            alert.error("Error Occured");
          }
          setisloginemail(false);
          setloginemail("");
          setloginpassword("");
          setloginmodal(false);
        })
        .catch((err) => {
          setloginemailloader(false);

          console.log("err", err);
          alert.error("Error Occured");
          setisloginemail(false);
          setloginemail("");
          setloginpassword("");
          setloginmodal(false);
        });
    });
  };

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const searchbyRegId = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please enter Admission Id or Name");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };

      fetch(`${baseUrl}/search_by_name_or_adm_id`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("Match not found");
            }
            setstudents(data.payload);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
            });
          }
        })
        .catch((err) => {
          console.log("err is re", err);
        });
    }
  };

  const onSectionChange = (id) => {
    setselectedsection(id);
  };

  const getConcessionTypes = () => {
    fetch(`${baseUrl}/concession`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setallconcessions(data.payload);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getHostelID = async () => {
    await fetch(`${baseUrl}/hostel`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallHostel(data.payload);
      })
      .catch((err) => {
        console.log("hostel", err);
      });
  };

  const getVehicleID = async () => {
    await fetch(`${baseUrl}/vehicle`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallVehical(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getPreviousSchool = async () => {
    await fetch(`${baseUrl}/previous-school`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setPreviousSchoolData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const handleShow = () => {
    if (campusId == "") {
      alert.error("Campus is required");
      return;
    }
    let data = {
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      global_section_id: sectionId,
      status: 2,
      year_id: yearId,
    };
    setloading(true);

    fetch(`${baseUrl}/student_filter_list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata) {
            if (data.payload.length == 0) {
              alert.error("No students found");
              setstudents([]);
              setloading(false);
              return;
            }
            if (data.metadata.success) {
              let res = data.payload.sort(
                (a, b) => a.admission_id - b.admission_id
              );
              let temparr = res;
              res.map((item, index) => {
                item["SrNo"] = index + 1;
                temparr[index] = item;
              });
              setstudents(temparr);
            }
          }
          setloading(false);
        })
      )

      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };
  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-5">
          <div className="col-sm-3">
            <label>
              <b>Select Session</b> <span style={{ color: "red" }}>*</span>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => setYearId(e.target.value)}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.year}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => onCampusChange(e.target.value)}
              className="form-select"
              style={{ backgroundColor: "white", height: 40 }}
              value={campusId}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>
              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Course </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="course_id"
              value={courseId}
              onChange={(e) => onCourseChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Course</option>
              {campusCourseData.map((item, index) => (
                <option key={index} value={item.course?.id}>
                  {item.course?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="class_id"
              value={classId}
              onChange={(e) => onClassChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {courseClassData.map((item, index) => (
                <option key={index} value={item.class?.id}>
                  {item.class?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-3">
            <label>
              <b>Select Section </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="section_id"
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              style={{ backgroundColor: "white" }}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {classSectionData.map((item, index) => (
                <option key={index} value={item.section?.id}>
                  {item.section?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-12">
            <button
              disabled={!PremissionChecker(user, "student.show")}
              className="btn btn-primary"
              onClick={handleShow}
            >
              Show
            </button>
          </div>
        </div>
        <form onSubmit={searchbyRegId}>
          <div className="row mt-5">
            <div className="col-md-4">
              <input
                onChange={(e) => setsearchtext(e.target.value)}
                className="form-control"
                placeholder="Enter Name or Admission ID"
              />
            </div>
            <div className="col-md-4">
              <button
                disabled={
                  !PremissionChecker(user, "student.get_student_by_adm_id")
                }
                type="submit"
                className="btn btn-primary"
              >
                Search
              </button>
            </div>
          </div>
        </form>

        {/* student table  */}
        <Table responsive>
          <thead>
            <tr id="tbl" className="text-center">
              <th>Sr. No</th>
              <th className="text-start">Student Name</th>
              <th className="text-start">Father Name</th>
              <th className="text-start">Class Section</th>
              <th>Admission ID</th>
              {PremissionChecker(user, "student.update") ? <th>Edit</th> : null}
              <th>SignUp/Reset</th>
              <th>View</th>
              {PremissionChecker(user, "student.struck_off") ? (
                <th>Stuck Off</th>
              ) : null}
            </tr>
          </thead>

          <tbody>
            {_DATA.currentData().map((student, index) => {
              return (
                // key={index}
                <tr className="text-center" key={index}>
                  <td>{student.SrNo}</td>
                  <td
                    title={student.name.length > 15 ? student.name : null}
                    style={{ textAlign: "start", cursor: "pointer" }}
                  >
                    {student.name}
                  </td>
                  <td
                    title={
                      student.father_name.length > 15
                        ? student.father_name
                        : null
                    }
                    style={{ textAlign: "start", cursor: "pointer" }}
                  >
                    {student.father_name.length > 15
                      ? student.father_name.substring(0, 12) + "..."
                      : student.father_name}
                  </td>
                  <td style={{ textAlign: "start" }}>
                    {student?.student_class?.name}&nbsp;
                    {student?.global_section?.name}&nbsp; (
                    {student?.campus?.name})
                  </td>

                  <td>{student.admission_id}</td>

                  {PremissionChecker(user, "student.update") ? (
                    <td>
                      <a
                        key={index}
                        className="btn btn-icon btn-light btn-hover-primary btn-sm "
                        onClick={(e) => {
                          openEditDialog(student);
                        }}
                      >
                        <span
                          key={index}
                          className="svg-icon svg-icon-md svg-icon-primary"
                        >
                          <SVG
                            key={index}
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Write.svg"
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  ) : null}

                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm "
                      onClick={() => {
                        setselectedStudent(student);
                        setloginemail(student.admission_id + domainStudent);
                        setloginmodal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                          style={{ margin: "10px" }}
                          className="logouticone"
                          src={
                            student.user_id == null
                              ? toAbsoluteUrl(
                                  "/media/svg/icons/Navigation/Sign-in.svg"
                                )
                              : toAbsoluteUrl(
                                  "/media/svg/icons/Navigation/Exchange.svg"
                                )
                          }
                        />
                      </span>
                    </a>
                  </td>

                  <td>
                    <a
                      style={{}}
                      className="btn btn-icon btn-light btn-hover-primary btn-sm "
                      onClick={() => gotoviewpage(student)}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Devices/Display2.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>

                  {PremissionChecker(user, "student.struck_off") ? (
                    <td>
                      <a
                        className="btn btn-icon btn-light btn-hover-primary btn-sm "
                        onClick={() => stuckOffFun(student)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Code/Error-circle.svg"
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
        </Table>

        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        <Pagination
          color="primary"
          count={count}
          size="large"
          page={page}
          variant="text"
          shape="round"
          onChange={handleChange}
        />

        <Modal onHide={() => seteditModal(false)} size="xl" show={editModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              {selectedStudent.name} {selectedStudent.admission_id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditStudent
              defConce={defaultCon}
              defaulthol={defaulthol}
              defaultVel={defaultVel}
              defaultSchool={defaultSchool}
              reloader={() => onSectionChange()}
              show={() => seteditModal()}
              reload={() => getAllStudents()}
              onUpdateStudent={getAllStudents}
              studentDetail={selectedStudent}
            />
          </Modal.Body>
        </Modal>
        <Modal onHide={() => setShowModal(false)} size="xl" show={showModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              {selectedStudent.name} {selectedStudent.admission_id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ViewStudent id={viewSelectedId} />
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-danger btn_width"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
        {/* setstuckoffmodal(true)
        setselectedStudent(student) */}

        <Modal show={stuckoffmodal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to Stuck Off Student?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <label className="form-control-label">
                  <b>
                    Select Date{" "}
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </b>
                </label>
                <input
                  value={dateData}
                  className="form-control"
                  onChange={(e) => setDateData(e.target.value)}
                  style={{}}
                  type="date"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {stuckoffloading ? (
              <b>
                <span className="spinner-border"></span>
              </b>
            ) : (
              <>
                <button
                  onClick={stuckOffHandler}
                  className="btn btn-success button_blue "
                >
                  Stuck Off
                </button>
                <button
                  className="btn btn-danger btn_width"
                  onClick={() => setstuckoffmodal(false)}
                >
                  Cancel
                </button>
              </>
            )}
          </Modal.Footer>
        </Modal>

        <Modal show={loginmodal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            ></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-between text-left">
              <div className="form-group row">
                <div className="form-group col-sm-10 flex-column d-flex">
                  <label>
                    Password <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    onChange={(e) => {
                      setloginpassword(e.target.value);
                      if (e.target.value == "") {
                        setisloginemail(true);
                      } else {
                        setisloginemail(false);
                      }
                    }}
                    placeholder="Password"
                    type="text"
                    className="form-control"
                  />
                </div>
                <div className="form-group col-sm-10 flex-column d-flex">
                  <label>Email</label>
                  <input
                    disabled
                    defaultValue={loginemail}
                    placeholder="Email"
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            {isloginemail ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisloginemail(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please Enter 6 digit Password</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {loginemailloader ? (
              <b>
                <span className="spinner-border"></span>
              </b>
            ) : (
              <>
                <button
                  onClick={loginHandler}
                  className="btn btn-success button_blue "
                >
                  {selectedStudent.user_id == null ? "Login" : "Reset"}
                </button>
                <button
                  className="btn btn-danger btn_width"
                  onClick={() => {
                    setisloginemail(false);
                    setloginemail("");
                    setloginpassword("");
                    setloginmodal(false);
                  }}
                >
                  Cancel
                </button>
              </>
            )}
          </Modal.Footer>
        </Modal>

        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete Student ?
            </Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <button
              onClick={deleteHandler}
              className="btn btn-success button_blue "
            >
              Delete
            </button>
            <button
              className="btn btn-danger btn_width"
              onClick={() => setdeleteModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </Paper>
    </div>
  );
}

export default ActiveStudents;
